import { getPriceWithCurrency } from 'src/utils';
import styles from './PackOption.module.scss';

interface PackOptionProps {
  value: number;
  credit: number;
}

export const PackOption = ({ value, credit }: PackOptionProps) => {
  return (
    <p className={styles.root}>
      <span className={styles.value}>{getPriceWithCurrency(value)}</span>

      <span className={styles.creditWrapper}>
        {value < credit && (
          <span className={styles.caption}>
            {getPriceWithCurrency(value, '', 0)}
          </span>
        )}

        <span
          className={styles.credit}
        >{`${getPriceWithCurrency(credit, '', 0)} credits`}</span>
      </span>
    </p>
  );
};
